<template>
  <div class="h5-sourcing">
    <div class="h5-sourcing-top-line" />
    <img
      src="@/assets/H5/offer/sourcing-close.svg"
      alt=""
      class="h5-sourcing-close"
      @click="closeSourcing"
    >

    <!-- 存在sku的情况 -->
    <div
      v-if="!!offerData?.productSkuInfos"
      class="h5-sourcing-content"
    >
      <div class="h5-sourcing-header">
        <Image
          :src="image"
          alt=""
          v-for="(image, index) in images"
          :key="index"
          class="h5-sourcing-header-item"
          :style="getItemStyle(index)"
          @loading-click.stop
          @click="handleImagePreview(index)"
        />
      </div>
      <div class="h5-sourcing-main">
        <div class="h5-sourcing-main-header">
          {{ offerData?.subjectTrans }}
        </div>
        <div class="h5-sourcing-main-line" />
        <H5PriceInterval
          :offer-data="offerData"
          :currency-data="currencyData"
        />
        <H5MinPriceInterval
          v-if="minPriceRange.length"
          :list="minPriceRange"
          :currency-data="currencyData"
        />

        <div class="attributes">
          <div class="firstAttributes">
            <div class="firstAttributes-title">
              {{
                (firstrAttributes?.[0]?.attributeNameTrans || "")
                  .charAt(0)
                  .toUpperCase() +
                  (firstrAttributes?.[0]?.attributeNameTrans || "").slice(1)
              }}:
              <span class="firstAttributes-title-sku">{{
                currentFirstSku
              }}</span>
            </div>
            <div class="firstAttributes-item">
              <div
                v-for="(item, index) in firstrAttributes"
                :key="index"
                @click="clickFirstAttributes(item, index)"
                :class="{
                  'firstAttributes-container': true,
                }"
              >
                <div
                  :class="{
                    activedAttributes: firstActivedAttributesIndex === index,
                  }"
                >
                  <Image
                    class="firstAttributes-container__image"
                    :src="item?.skuImageUrl || defaultImage"
                    alt=""
                  />
                </div>
                <div class="firstAttributes-item-title">
                  <span>
                    {{
                      item?.valueTrans?.charAt(0).toUpperCase() +
                        item?.valueTrans?.slice(1)
                    }}
                  </span>
                </div>
                <div
                  class="firstAttributes-item-total"
                  v-if="item?.total"
                >
                  ×{{ item?.total }}
                </div>
              </div>
            </div>
          </div>

          <div class="secondAttributes">
            <div class="secondAttributes-title">
              <div
                class="secondAttributes-title-left"
                :style="{
                  color: !isAddCarts
                    ? '#232323'
                    : offerData?.minOrderQuantity > estimatedQuntity
                      ? '#F53131'
                      : '#232323',
                }"
              >
                {{ secondAttributesQuantityList[0]?.skuAttributes?.[1]?.attributeNameTrans ?? 'Quantity' }}
              </div>
              <div
                class="secondAttributes-title-right"
                :style="{
                  color: !isAddCarts
                    ? '#232323'
                    : offerData?.minOrderQuantity > estimatedQuntity
                      ? '#F53131'
                      : '#232323',
                }"
              >
                Min. Order: {{ offerData?.minOrderQuantity }} PCS
              </div>
            </div>
            <div class="secondAttributes-item">
              <div
                v-for="(item, index) in secondAttributesQuantityList"
                :key="index"
                class="secondAttributes-container"
              >
                <div class="secondAttributes-valueTrans">
                  {{ item?.skuAttributes?.[1]?.valueTrans }}
                </div>
                <div class="secondAttributes-container-main">
                  <div class="secondAttributes-price">
                    <span>{{ currencyData?.targetUnit
                    }}{{
                      bankersRound(
                        renderPrice(item?.price, item) * currencyData?.rate,
                        2
                      )
                    }}
                    </span>
                    <!-- /
                    <span
                      >{{ currencyData?.fromUnit
                      }}{{ renderPrice(item?.price) }}</span
                    > -->
                  </div>
                  <div class="secondAttributes-inStock">
                    {{ item?.amountOnSale }} in stock
                  </div>

                  <div class="secondAttributes-btn">
                    <div
                      class="secondAttributes-btn-sub"
                      @click="attributesSub(item, index)"
                    >
                      <img
                        :id="'secondAttributes-btn-sub-' + index"
                        :src="secondAttributesBtnReduce"
                        alt=""
                      >
                    </div>
                    <input
                      class="secondAttributes-btn-input"
                      v-model="item.quantity"
                      type="number"
                      @change="(e) => changeAttributes(item, index, e)"
                    >
                    <div
                      class="secondAttributes-btn-add"
                      :class="{ active: item.quantity > 0 }"
                      @click="attributesAdd(item, index)"
                    >
                      <img
                        v-if="item.quantity > 0"
                        src="@/assets/H5/offer/plus-icon-white.svg"
                        alt=""
                      >
                      <img
                        v-else
                        :id="'secondAttributes-btn-add-' + index"
                        :src="secondAttributesBtnAdd"
                        alt=""
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="h5-sourcing-footer-line" />

        <div class="h5-delivery">
          <div
            class="h5-delivery-header"
            ref="deliveryRef"
          >
            Delivery
          </div>
          <div class="h5-shipto">
            <div
              class="h5-shipto-left"
              @click="showSelectCountry"
            >
              <img
                src="@/assets/H5/offer/shipto.svg"
                alt=""
              >
              <span class="h5-shipto-left-title">Shipping to:</span>
              <img
                :src="shipCountry?.countryUrl"
                alt=""
                class="ship-country-img"
              >
              <span class="ship-main-title">{{
                shipCountry?.countryName
              }}</span>
              <img
                src="@/assets/H5/offer/shipto-right.svg"
                alt=""
                @click="handleH5SourcingPopup"
              >
            </div>
          </div>
          <div class="h5-supplier">
            <div class="h5-supplier-left">
              <img
                src="@/assets/H5/offer/supplier.svg"
                alt=""
                class="h5-supplier-left-1"
              >
              <span class="h5-supplier-left-2">Fulfillment Supplier:</span>
              <img
                class="h5-supplier-left-3"
                src="@/assets/H5/offer/logo.svg"
                alt=""
              >
            </div>
            <div class="h5-supplier-right h5-supplier-right-2">
              <!-- <span class="h5-supplier-right-1">1688.com</span> -->
              <!-- <span class="h5-supplier-right-2"
                >Professional international fulfillment services</span
              > -->
              Professional international fulfillment services
            </div>
          </div>
          <div class="h5-supplier">
            <div class="h5-supplier-left">
              <img
                src="@/assets/offer/bank-card.svg"
                alt=""
                class="h5-supplier-left-1"
              >
              <span class="h5-supplier-left-2">Payment Methods:</span>
              <div class="with-support">
                with
                <img
                  src="@/assets/illus/illus-paypal.svg"
                  alt=""
                >
                or
                <span>Bank Transfer</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 无sku的情况 -->
    <div
      v-if="!offerData?.productSkuInfos"
      class="h5-nosku-sourcing"
    >
      <div class="h5-nosku-main">
        <div class="h5-sourcing-main-header">
          {{ offerData?.subjectTrans }}
        </div>
        <div class="h5-sourcing-main-line" />
        <div
          class="h5-interval"
          v-if="!offerData?.productSkuInfos?.[0]?.price"
        >
          <div
            v-for="(item, index) in offerData?.productSaleInfo?.priceRangeList"
            class="h5-interval-item"
            :key="index"
          >
            <div class="interval-item-pcs">
              {{ item?.startQuantityStr }} PCS
            </div>
            <div class="interval-item-price">
              <span>{{ currencyData?.targetCurrency }}</span>
              <span>{{ currencyData?.targetUnit }}</span>
              <span>{{
                bankersRound(currencyData?.rate * item?.price, 2)
              }}</span>
            </div>
          </div>
        </div>
        <div class="nosku-attributes">
          <div class="noAttributes-header">
            <div
              class="noAttributes-header-left"
              :style="{
                color: !isAddCarts
                  ? '#232323'
                  : offerData?.minOrderQuantity > estimatedQuntity
                    ? '#F53131'
                    : '#232323',
              }"
            >
              Quantity: {{ noSkuNum }}
            </div>
            <div
              class="noAttributes-header-right"
              :style="{
                color: !isAddCarts
                  ? '#232323'
                  : offerData?.minOrderQuantity > estimatedQuntity
                    ? '#F53131'
                    : '#232323',
              }"
            >
              Min. Order: {{ offerData?.minOrderQuantity }} Piece
            </div>
          </div>
          <div class="noAttributes">
            <div class="secondAttributes-price">
              <span>{{ currencyData?.targetUnit }}
                {{ bankersRound(renderNoSkuPrice() * currencyData?.rate, 2) }}
              </span>
              <!-- /
              <span>{{ currencyData?.fromUnit }}{{ renderNoSkuPrice() }}</span> -->
            </div>
            <div class="secondAttributes-inStock">
              {{ offerData?.productSaleInfo?.amountOnSale }} InStock
            </div>
            <div class="secondAttributes-btn">
              <div
                class="secondAttributes-btn-sub"
                @click="noAttributesSub()"
              >
                <img
                  src="@/assets/offer/sub.svg"
                  alt=""
                >
              </div>
              <input
                class="secondAttributes-btn-input"
                @change="(e) => changeNoAttributes(e)"
                v-model="noSkuNum"
              >
              <div
                class="secondAttributes-btn-add"
                @click="noAttributesAdd"
              >
                <img
                  src="@/assets/offer/add.svg"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h5-delivery">
        <div
          class="h5-delivery-header"
          ref="deliveryRef"
        >
          Delivery
        </div>
        <div class="h5-shipto">
          <div
            class="h5-shipto-left"
            @click="showSelectCountry"
          >
            <img
              src="@/assets/H5/offer/shipto.svg"
              alt=""
            >
            <span class="h5-shipto-left-title">Shipping to:</span>
            <img
              :src="shipCountry?.countryUrl"
              alt=""
              class="ship-country-img"
            >
            <span class="ship-main-title">{{
              shipCountry?.countryName
            }}</span>
            <img
              src="@/assets/H5/offer/shipto-right.svg"
              alt=""
              @click="handleH5SourcingPopup"
            >
          </div>
        </div>
        <div class="h5-supplier">
          <div class="h5-supplier-left">
            <img
              src="https://cdn-image.bestdealer.com/app-bestdealer/1688/offer/supplier-icon.svg"
              alt=""
              class="h5-supplier-left-1"
            >
            <span class="h5-supplier-left-2">Fulfillment Supplier:</span>
            <img
              class="h5-supplier-left-3"
              src="@/assets/H5/offer/logo.svg"
              alt=""
            >
          </div>
          <div class="h5-supplier-right">
            <span class="h5-supplier-right-1">1688.com</span>
            <span class="h5-supplier-right-2">shipping protection available with 1688 official partner</span>
          </div>
        </div>
        <div class="h5-supplier">
          <div class="h5-supplier-left">
            <img
              src="https://cdn-image.bestdealer.com/app-bestdealer/1688/offer/payment-icon.svg"
              alt=""
              class="h5-supplier-left-1"
            >
            <span class="h5-supplier-left-2">Payment Methods:</span>
            <img
              class="h5-supplier-left-2-img"
              src="@/assets/offer/pay-method.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="h5-sourcing-footer"
    >
      <Transition name="est-info">
        <div
          v-if="shipPackage.shipAmount"
          class="est-info"
        >
          <div class="est-info-item">
            <div class="left">
              Total Items
            </div>
            <div class="right">
              {{ currencyData?.targetCurrency?.slice(0, 2) }} {{ currencyData.targetUnit }}{{ shipPackage.itemAmount || 0 }}
            </div>
          </div>
          <div class="est-info-item">
            <div class="left">
              Est.Shipping
              <Tooltip
                :offset="4"
                trigger="click"
                placement="top"
              >
                <template #content>
                  <div
                    v-if="hasMapping"
                    style="width: 150px;"
                  >
                    When you buy different items, Bestdealer will intelligently combine these items for shipment, and the shipping cost may be lower.
                  </div>
                  <div
                    v-else
                    style="width: 150px;"
                  >
                    The length, width, height and weight of the items currently provided by the merchant have not been inspected by Bestdealer's warehouse and may have certain deviations.
                  </div>
                </template>
                <Icon name="icon-help-tip-l" />
              </Tooltip>
            </div>
            <div class="right">
              <div
                v-if="Number(shipPackage.shipAmount) === 0"
                class="free-shipping"
              >
                Free Shipping
              </div>
              <div v-else>
                {{ currencyData?.targetCurrency?.slice(0, 2) }} {{ currencyData.targetUnit }}{{ shipPackage.shipAmount || 0 }}
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <div
        class="est-info"
        style="height: auto;"
      >
        <div class="est-info-item">
          <div class="left">
            <span class="prefix">Total Cost</span>
            (<span class="estimatedQuntity">{{ skuQuntity }}</span> items,
            <span class="estimatedQuntity">{{ estimatedQuntity }}</span> pcs)
          </div>
          <div class="right">
            <IntlCurrency
              :count="shipPackage.totalAmount || 0"
              :size="18"
              :currency="currencyData?.targetCurrency.slice(0, 2)"
              color="#052784"
            />
          </div>
        </div>
      </div>
      <div class="h5-sourcing-add-carts">
        <div
          class="h5-sourcing-carts"
          @click="handleAddCarts"
          ref="cartIcon"
        >
          <div class="carts-nums">
            {{
              cartCount > 99 ? "+99" : cartCount === 0 ? "0" : "+" + cartCount
            }}
          </div>
          <img
            src="@/assets/H5/offer/carts.svg"
            alt=""
            class="carts-icon"
          >
        </div>
        <div
          v-if="sourcingStatusInfo?.status"
          class="h5-sourcing-footer-btn"
          @click="addCarts"
          ref="addToCartBtn"
        >
          Add to Cart
          <div
            v-if="sourcingStatusInfo?.status !== 1"
            :class="[
              {
                parabolaActive: isParabolaActive,
              },
              'footer-btn-parabola',
            ]"
          />
        </div>
      </div>
    </div>
    <!-- 引入抛物线动画组件 -->
    <AddToCartAnimation
      ref="animation"
      :start-element="startElement"
      :end-element="endElement"
      :color="animationColor"
      :duration="animationDuration"
      :parabolic-height="parabolicHeight"
      :size="animationSize"
      @animation-end="onAnimationEnd"
    />
    <H5Dialog
      v-model="showH5ShipTo"
      height="98%"
      :init-styles="{ background: 'white' }"
    >
      <H5ShipTo
        @save="handleUpdateCountry"
        :country-list="countryList"
        :current-country="shipCountry"
        :handle-close="closeH5ShipTo"
      />
    </H5Dialog>
    <div
      class="pop-container-wrapper"
      v-if="showAddressInfo"
      :class="{ visible: showAddressInfo }"
    >
      <div class="pop-container-header">
        <img
          src="@/assets/H5/orderFilling/h5-back.svg"
          alt=""
          class="pop-container-header-back"
          @click="handleCloseAddressInfo(false)"
        >
        <div class="pop-container-header-title">
          Shipping Address
        </div>
        <img
          src="@/assets/H5/offer/sourcing-close.svg"
          alt=""
          class="pop-container-header-close"
          @click="handleCloseAddressInfo(false)"
        >
      </div>
      <div
        class="pop-container"
        :class="{ visible: showAddressInfo }"
        @click.stop
      >
        <H5AddressInfo
          v-if="showAddressInfo"
          :handle-close="handleCloseAddressInfo"
          :current-country="currentCountry"
          :address-type="addressType"
        />
      </div>
    </div>

    <ExceedQuantityDialog
      v-if="exceedOrderQuantityDialog"
      @close="exceedOrderQuantityDialog = false"
      :quantity="offerData?.minOrderQuantity"
    />

    <div
      ref="sourcingTipRef"
      class="h5-soucing-tip"
      :style="{ bottom: shipPackage.shipAmount ? '165px' : '113px' }"
    >
      <div class="h5-soucing-tip-header">
        <div class="title">
          Pending Processing
        </div>
        <div
          @click="closeSourcingTip"
          class="close"
        >
          <img
            src="@/assets/images/icon-close-light.svg"
            alt=""
          >
        </div>
      </div>
      <div class="text">
        Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
      </div>
      <div
        @click="contactUs"
        class="contact-us"
      >
        Free Expert Consultation Now!
        <img
          src="@/assets/images/icon-arrow-right.svg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  reactive,
  ref,
  toRaw,
  watch
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { fetchData } from '../../../../../../utils/fetch'
import { bankersRound, buriedPointUtil, gaAnalytics, metaPixelTrack } from '../../../../../../utils/utils'
import H5Dialog from '@/components/H5/H5Dialog/index.vue'
import H5ShipTo from '@/components/H5/H5ShipTo/index.vue'
import H5PriceInterval from '../H5PriceInterval/index.vue'
import H5MinPriceInterval from '../H5MinPriceInterval/index.vue'
import defaultImage from '@/assets/empty-image.svg'
import { usePlugin } from '@/hooks/usePlugin'
import H5AddressInfo from '@/components/H5/H5AddressInfo/index.vue'
import AddToCartAnimation from '../AddToCartAnimation/index.vue'
import { useLoginModal } from '@/components/Login'
import { useUserStore } from '@/pinia/user'
import ExceedQuantityDialog from '@/components/H5/ExceedQuantityDialog/index.vue'
import { useIntercom } from '@/hooks/useIntercom'
import storage from '@/utils/storage'
import { useCurrencyJudge } from '@/hooks/useCurrencyJudge'
import Icon from '@/components/Icon/Icon.vue'
import Tooltip from '@/components/Tooltip/index.vue'
import Popover from '@/components/Popover/index.vue'
import { Image } from '@/components/Image'
import { useImagePreview } from '@/hooks/useImagePreview'

const store = useStore()
const route = useRoute()
const router = useRouter()
const { open: openLoginModal } = useLoginModal()
const user = useUserStore()

const { showNewMessage } = useIntercom()
const { showImagePreviewWithSimilar } = useImagePreview()

const props = defineProps({
  offerData: Object,
  closeH5Sourcing: Function,
  currentCountry: Object,
  newParam: Object,
  hasMapping: Boolean
})
const offerData = props.offerData
const closeH5Sourcing = props.closeH5Sourcing
const sourcingStatusInfo = ref({
  status: '',
  message: ''
})
const firstrAttributes = ref([])
const images = computed(() => firstrAttributes.value.map(item => {
  return item.skuImageUrl ?? defaultImage
}))
const secondAttributesQuantityList = ref([])
const secondAttributesQuantityObj = reactive({})
const countryList = computed(() => store.state.countryInfo)

const firstActivedAttributesIndex = ref(0)
const endTouchX = ref(0)

const currencyData = computed(() => store.state.currencyData)
const supplierFee = computed(() => store.state.supplierFee)
const mergedArray = computed(() => store.state.mergedArray)
const currentFirstSku = ref('')
const showH5ShipTo = ref(false)
const deliveryRef = ref(null)
const isParabolaActive = ref(false)
const showAddressInfo = ref(false)
const isAddCarts = ref(false)

// 动画参数
const startElement = ref(null)
const endElement = ref(null)
const animationColor = ref('#052784')
const animationDuration = ref(500)
const parabolicHeight = ref(260)
const animationSize = ref(18)

const cartIcon = ref(null)
const addToCartBtn = ref(null)
const animation = ref(null)

const addressType = ref(sourcingStatusInfo?.value?.status === 4 ? 1 : 2)

const exceedOrderQuantityDialog = ref(false)

const { $toast } = usePlugin()
// 无sku处理
const noSkuNum = ref(0)

const totalQuantity = ref(0)

const currentCountry = computed(() => store.state.currentCountry)
const cartCount = computed(() => store.state.cart.cartCount)
const shipInfo = computed(() => store.state.shipInfo)

const shipCountry = computed(() => {
  const country = shipInfo.value.country
  if (country) return country

  // 默认显示美国
  const usCountry = countryList.value.find(item => item.countryCode === 'US')
  return usCountry
})

const estimatedQuntity = computed(() => {
  if (mergedArray.value == null) return 0
  return mergedArray.value.reduce((pre, cur) => {
    return pre + cur.quantity
  }, 0)
})

// sku的选择数量
const skuQuntity = computed(() => {
  const skuAttributes = mergedArray.value.map(item => {
    const skuAttributes = item.skuAttributes
    return skuAttributes[0].value
  })

  const uniqueSkuAttributes = [...new Set(skuAttributes)]
  return uniqueSkuAttributes.length
})

const closeSourcing = () => {
  const intercom = document.querySelector('.intercom-lightweight-app')
  if (intercom) {
    intercom.style.display = 'block' // 隐藏元素
  }
  closeH5Sourcing(true)
}

watch(currencyData, (newData) => {
  if (newData) {
    currencyData.value = newData
  }
})

watch(supplierFee, (newData) => {
  if (newData) {
    supplierFee.value = newData
  }
})

// 获取预估费用
watch(mergedArray, (value) => {
  if (value.length > 0) {
    getShipPackage()
  } else {
    shipPackage.value = {}
  }
})

let fetchId = 0 // 竞态处理
const shipPackage = ref({})
const getShipPackage = async () => {
  if (!mergedArray.value.length) return

  fetchId += 1
  const currentId = fetchId

  const offerId = route.params.id
  const params = {
    address: {
      countryCode: shipCountry.value.countryCode,
      zip: shipInfo.value.postCode
    },
    details: mergedArray.value.map(item => ({
      offerId,
      skuId: item.skuId,
      quantity: item.quantity
    })),
    currency: currencyData.value.targetCurrency
  }

  fetchData('/appb/b2b/fee/calcProductFulfillmentFee', {
    method: 'post',
    body: JSON.stringify(params)
  }).then(res => {
    if (currentId === fetchId) {
      const details = res.data.details
      shipPackage.value = details[0].shipPackage
    }
  })
}

const IMAGES = {
  addDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add_default.svg',
  add: 'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add.svg',
  reduceDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce_default.svg',
  reduce:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce.svg',
  irreducible:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/irreducible.svg',
  cannotBeAdded:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/cannot_be_added.svg'
}
const secondAttributesBtnAdd = ref(IMAGES.addDefault)
const secondAttributesBtnReduce = ref(IMAGES.irreducible)

onMounted(async () => {
  await querySourcingStatus()
  if (user.isLogged) {
    await getSkuCartStatus(offerData)
  }
  firstSku(offerData?.productSkuInfos)
})

const statusSkuList = ref([])
const querySourcingStatus = async () => {
  const { code, data } = await fetchData('/appb/alibaba-common/offerDetail/sourcingStatusV2', {
    method: 'POST',
    body: JSON.stringify({
      offerId: route.params.id,
      skuIds: offerData?.productSkuInfos.map(item => item.skuId)
    })
  })

  if (code === 200) {
    sourcingStatusInfo.value = data
    if (data.status === 1 || data.status === 2) {
      statusSkuList.value = data.skuList
      sourcingStatusInfo.value.status = data.skuList[0].status
    }
  }
}

// 获取购物车商品状态
const skuCartStatus = ref([])
const getSkuCartStatus = async (obj) => {
  const offerId = obj.offerId
  const params = {
    spuId: offerId,
    skuIds: obj.productSkuInfos.map(item => item.skuId)
  }
  const { code, data } = await fetchData('/appb/b2b/cart/getPendingSkuBySpu', {
    method: 'post',
    body: JSON.stringify(params)
  })
  skuCartStatus.value = data || []
}

const firstSku = (productSkuInfos) => {
  const colorAttributes = productSkuInfos?.map((sku) => {
    const skuAttribute = sku.skuAttributes[0] // 获取每个 SKU 中的第一个 skuAttribute（颜色）
    return {
      ...skuAttribute,
      skuId: sku.skuId
    }
  })
  const uniqueColors = colorAttributes?.filter((value, index, self) => {
    return index === self.findIndex((t) => t.valueTrans === value.valueTrans)
  })
  firstrAttributes.value = uniqueColors.map(item => {
    delete item.total
    return item
  })

  // 默认记录第一个
  clickFirstAttributes(firstrAttributes.value[0], 0)

  currentFirstSku.value = uniqueColors?.[0]?.valueTrans
  secondSku(productSkuInfos, uniqueColors?.[0], 0)
}

const secondSku = (
  productSkuInfos,
  currentFirstSelectedObj,
  uniqueColorsIndex
) => {
  const sizeList = productSkuInfos?.filter((v) => {
    return (
      v.skuAttributes[0].valueTrans === currentFirstSelectedObj?.valueTrans
    )
  })
  /**
   * sku 没有库存的情况下，将该 sku 移动到列表最后
   */
  const list = sizeList?.map((v) => {
    return { ...v, quantity: 0 }
  }).sort((a, b) => b.amountOnSale > 0 ? 1 : (a.amountOnSale > 0 ? -1 : 1))
  if (Reflect.has(secondAttributesQuantityObj, uniqueColorsIndex)) {
    secondAttributesQuantityList.value = secondAttributesQuantityObj[uniqueColorsIndex]
  } else {
    secondAttributesQuantityList.value = list
    secondAttributesQuantityObj[uniqueColorsIndex] = list
  }

  if (!offerData.productSaleInfo.priceRangeList) {
    handleMinPriceRange()
    return
  }
  // 更新secondAttributesQuantityList的sku价格
  secondAttributesQuantityList.value.forEach(item => {
    const price = getPriceByQuantity(totalQuantity.value, offerData.productSaleInfo.priceRangeList)
    item.price = price
  })
}

const minPriceRange = ref([])
const handleMinPriceRange = () => {
  let price = secondAttributesQuantityList.value[0].price

  secondAttributesQuantityList.value.forEach(item => {
    const p = Number(item.price)
    if (price > p) {
      price = p
    }
  })
  minPriceRange.value = [{
    startQuantityStr: '>=' + offerData.minOrderQuantity,
    price
  }]
}

// 点第一个sku
const clickFirstAttributes = (item, index) => {
  // 判断是否显示tip弹窗
  isShowSourcingTip(item.skuId)

  firstActivedAttributesIndex.value = index
  currentFirstSku.value = item.valueTrans

  endTouchX.value = 0
  secondSku(offerData.productSkuInfos, item, index)
}

const getPriceByQuantity = (quantity, priceRange) => {
  let validPrices = priceRange.filter(item => item.startQuantity <= quantity)
  if (validPrices.length === 0) {
    validPrices = [priceRange[0]]
  }

  const bestMatch = validPrices.reduce((prev, curr) =>
    curr.startQuantity > prev.startQuantity ? curr : prev
  )
  return Number(bestMatch.price)
}
const { judgeCurrency } = useCurrencyJudge()
const updateSkuPrice = () => {
  judgeCurrency()
  const priceRangeList = offerData?.productSaleInfo?.priceRangeList
  if (!priceRangeList) return

  let quantity = 0
  Object.keys(secondAttributesQuantityObj).forEach((key) => {
    secondAttributesQuantityObj[key].forEach((item) => {
      quantity += item.quantity
    })
  })

  const price = getPriceByQuantity(quantity, priceRangeList)
  secondAttributesQuantityList.value.forEach(item => {
    item.price = price
  })
}

const attributesSub = (item, index) => {
  if (secondAttributesQuantityList.value[index].quantity <= 0) {
    return
  }
  secondAttributesQuantityList.value[index].quantity -= item.bundleQuantity

  firstSkuTotal()
  postLtogisticFee()
}

const attributesAdd = (item, index) => {
  if (secondAttributesQuantityList.value[index].quantity >= item.amountOnSale) {
    return
  }
  secondAttributesQuantityList.value[index].quantity += item.bundleQuantity

  firstSkuTotal()
  postLtogisticFee()
}

const firstSkuTotal = () => {
  const currentValueTrans =
    secondAttributesQuantityList.value[0].skuAttributes?.[0].valueTrans || ''
  const newfirstList = toRaw(firstrAttributes.value)
  const _index = newfirstList?.findIndex(
    (v) => v.valueTrans === currentValueTrans
  )

  if (_index !== -1) {
    let total = 0
    secondAttributesQuantityList.value?.forEach((v) => {
      const quantity = v.quantity ? v.quantity : 0
      total += Number(quantity)
    })

    firstrAttributes.value[_index].total = total
  }
}

const postLtogisticFee = () => {
  const skuSales = []
  totalQuantity.value = 0
  Object.entries(secondAttributesQuantityObj).forEach(([, value]) => {
    value.forEach((v) => {
      if (v?.quantity > 0) {
        totalQuantity.value += Number(v.quantity)
        skuSales.push(toRaw(v))
      }
    })
  })

  const mergedArray = skuSales?.map((detail) => {
    const productSkuInfos = offerData?.productSkuInfos
    const matchingSale = productSkuInfos?.find((sale) => sale.skuId === detail.skuId)
    updateSkuPrice()
    return {
      spuId: offerData.offerId,
      skuId: detail.skuId,
      quantity: detail.quantity,
      spuName: offerData.subjectTrans,
      skuImage: matchingSale.skuAttributes?.[0]?.skuImageUrl,
      batchNum: offerData.minOrderQuantity,
      skuAttributes: matchingSale.skuAttributes
        ? matchingSale.skuAttributes.map((v) => {
          return {
            name: v.attributeNameTrans,
            value: v.valueTrans
          }
        })
        : [],
      targetPrice: bankersRound(detail?.price * currencyData.value.rate, 2),
      price: detail?.price
    }
  })
  if (!!mergedArray && !mergedArray.length) {
    store.commit('setSupplierFee', {
      supplierFee: 0,
      suppliersName: '',
      suppliersUrl: ''
    })
    store.commit('setMergedArray', [])
    return
  }

  store.commit('setMergedArray', mergedArray)
}

const renderPrice = (price) => {
  if (!price) {
    const skuSales = []
    let totalQuantity = 0
    Object.entries(secondAttributesQuantityObj).forEach(([, value]) => {
      value.forEach((v) => {
        if (v?.quantity > 0) {
          skuSales.push(toRaw(v))
        }
      })
    })
    skuSales.forEach((v) => {
      totalQuantity += v.quantity
    })
    const matchedPrice = offerData?.productSaleInfo?.priceRangeList
      .filter((range) => totalQuantity >= range.startQuantity)
      .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price
    if (!matchedPrice) {
      return offerData?.productSaleInfo?.priceRangeList?.[0]?.price
    }
    if (matchedPrice) {
      return matchedPrice
    }
  } else {
    return price
  }
}

// 捆绑数量算法
const calcBundleQuantity = (data) => {
  const bundleQuantity = +data.bundleQuantity
  const halfBundle = bundleQuantity / 2
  let quantity = +data.quantity
  quantity = (Math.floor((quantity + halfBundle) / bundleQuantity)) * bundleQuantity
  if (quantity <= 0) {
    quantity = bundleQuantity
  }
  return quantity
}

const changeAttributes = (item, index) => {
  let value = calcBundleQuantity(item)
  if (value >= item.amountOnSale) {
    value = item.amountOnSale
  }
  if (value <= 0) {
    value = 0
  }
  secondAttributesQuantityList.value[index].quantity = value

  firstSkuTotal()
  postLtogisticFee()
}

const updateButtonImage = (element, src) => {
  if (element) {
    element.src = src
  }
}

// watch 更新按钮图标
watch(
  secondAttributesQuantityList,
  (_1, _2) => {
    secondAttributesQuantityList.value?.forEach((item, i) => {
      const imgElementSub = document.getElementById(
        'secondAttributes-btn-sub-' + i
      )
      const imgElementAdd = document.getElementById(
        'secondAttributes-btn-add-' + i
      )

      if (item.quantity === 0) {
        updateButtonImage(imgElementSub, IMAGES.irreducible)
        updateButtonImage(imgElementAdd, IMAGES.addDefault)
      } else if (item.quantity >= item.amountOnSale) {
        updateButtonImage(imgElementSub, IMAGES.reduceDefault)
        updateButtonImage(imgElementAdd, IMAGES.cannotBeAdded)
      } else {
        if (imgElementSub.src !== IMAGES.reduce) {
          updateButtonImage(imgElementSub, IMAGES.reduceDefault)
        }

        if (imgElementAdd?.src !== IMAGES.add) {
          updateButtonImage(imgElementAdd, IMAGES.addDefault)
        }
      }
    })
  },
  { deep: true }
)

const getItemStyle = () => {
  const translateX = (0 - firstActivedAttributesIndex.value) * 180
  return {
    transform: `translateX(${translateX}px)`,
    transition: 'transform 0.5s ease-in-out'
  }
}

const showSelectCountry = () => {
  showH5ShipTo.value = true
}

const closeH5ShipTo = () => {
  if (offerData?.productSkuInfos) {
    postLtogisticFee()
  } else {
    postNoskuPrice()
  }
  showH5ShipTo.value = false
}

const handleUpdateCountry = () => {
  showH5ShipTo.value = false
  getShipPackage()
}

const renderNoSkuPrice = () => {
  const matchedPrice = offerData?.productSaleInfo?.priceRangeList
    .filter((range) => noSkuNum.value >= range.startQuantity)
    .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price

  if (!matchedPrice) {
    return offerData?.productSaleInfo?.priceRangeList[0]?.price
  }
  return matchedPrice
}

const noAttributesSub = () => {
  if (noSkuNum.value <= 0) {
    noSkuNum.value = 0
    return
  }
  noSkuNum.value = Number(noSkuNum.value) - 1
  postNoskuPrice()
}

const noAttributesAdd = () => {
  if (noSkuNum.value >= offerData?.productSaleInfo?.amountOnSale) {
    noSkuNum.value = Number(offerData?.productSaleInfo?.amountOnSale)
    return
  }
  noSkuNum.value = Number(noSkuNum.value) + 1
  postNoskuPrice()
}

const changeNoAttributes = (e) => {
  let value = Number(e.target.value.replace(/[^0-9]/g, ''))
  if (value >= offerData?.productSaleInfo?.amountOnSale) {
    value = offerData?.productSaleInfo?.amountOnSale
  }
  if (value <= 0) {
    value = 0
  }
  noSkuNum.value = Number(value)
  postNoskuPrice()
}

const postNoskuPrice = async () => {
  const matchedPrice =
    offerData?.productSaleInfo?.priceRangeList
      .filter((range) => noSkuNum.value >= range.startQuantity)
      .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price ||
    offerData?.productSaleInfo?.priceRangeList[0]?.price

  // sourcing now逻辑
  if (sourcingStatusInfo?.value?.status === 4) {
    const obj = {
      ...offerData.productShippingInfo?.defaultShippingInfo,
      price: matchedPrice,
      quantity: noSkuNum.value,
      targetPrice: bankersRound(matchedPrice * currencyData.value.rate, 2)
    }
    const logisticFeeProductInputs = [
      {
        offerId: offerData.offerId,
        titleCn: offerData.subject,
        categoryId: offerData.categoryId,
        productUrl: window.location.href,
        skuShipInfos: [obj]
      }
    ]

    if (!matchedPrice) {
      store.commit('setMergedArray', logisticFeeProductInputs)
      return
    }

    store.commit('setMergedArray', [obj])
    return
  }
  const obj = {
    spuId: offerData.offerId,
    quantity: noSkuNum.value,
    spuName: offerData.subjectTrans,
    batchNum: offerData.minOrderQuantity,
    targetPrice: bankersRound(matchedPrice * currencyData.value.rate, 2)
  }

  store.commit('setMergedArray', [obj])
}
const onAnimationEnd = () => {
  console.log('动画结束')
  const cartsNums = document.querySelector('.carts-nums')
  console.log(cartsNums, 'cartsNums')
  if (cartsNums) {
    // 添加抖动动画
    cartsNums.classList.add('shake-animation')
    cartsNums.addEventListener('animationend', () => {
      cartsNums.classList.remove('shake-animation')
    })
  }
  const cartsIcon = document.querySelector('.carts-icon')
  if (cartsIcon) {
    // 添加缩放动画
    cartsIcon.classList.add('scale-animation')
    cartsIcon.addEventListener('animationend', () => {
      cartsIcon.classList.remove('scale-animation')
    })
  }
}

const addCarts = async () => {
  if (!user.userInfo.tk) {
    openLoginModal()
    closeH5Sourcing()
    return
  }

  const addressForm = localStorage.getItem('addressForm')
    ? JSON.parse(localStorage.getItem('addressForm'))
    : null
  if (!addressForm) {
    showAddressInfo.value = true
    return
  }

  if (!estimatedQuntity.value) {
    $toast('Quantity cannot be empty.', { type: 'error' })
    isAddCarts.value = true
    return
  }

  const { minOrderQuantity } = offerData
  if (minOrderQuantity > estimatedQuntity.value) {
    $toast('The minimum order quantity for the product has not been reached. Please continue to add products.', {
      type: 'error'
    })
    isAddCarts.value = true
    return
  }

  /**
   * Meta Pixel 埋点：点击加入购物车
   */
  metaPixelTrack('PAC201', 'AddToCart', {
    content_ids: [offerData.offerId],
    content_type: 'product',
    currency: '$',
    value: 2
  })

  const details = mergedArray.value.map(item => ({ ...item, spuId: offerData.offerId }))
  const { code, msg } = await fetchData('/appb/b2b/cart/cartAddV2', {
    method: 'post',
    body: JSON.stringify({
      currency: currencyData.value.targetCurrency,
      currencyUnit: currencyData.value.targetUnit,
      details
    })
  })
  if (code === 200) {
    setTimeout(() => {
      $toast('Added successfully', { type: 'success' })
    }, 700)
    gaAnalytics('mp_add_to_cart_success', 'mp_add_to_cart_success')
    buriedPointUtil({ eventId: 'MPPD601' })
    await getCartCount()
    secondAttributesQuantityList?.value.forEach((item) => {
      item.quantity = 0
    })
    firstrAttributes.value?.forEach((item) => {
      item.total = 0
    })
    noSkuNum.value = 0
    store.commit('setMergedArray', [])
    await getSkuCartStatus(offerData)
    firstSku(offerData?.productSkuInfos)
  } else if ([5216, 5217].includes(code)) {
    $toast(msg, { type: 'error' })
  } else if (code === 200001) {
    $toast('Please fill delivery address.')
    localStorage.removeItem('addressForm')
    showAddressInfo.value = true
  } else if (code === 100001) {
    exceedOrderQuantityDialog.value = true
  } else {
    $toast('Add to cart failed', { type: 'error' })
  }
}

const getCartCount = async () => {
  const { code, data } = await fetchData('/appb/b2b/cart/cartCount')
  if (code === 200) {
    store.commit('cart/SET_CART_COUNT', data)
  }
}

const handleCloseAddressInfo = (saved) => {
  showAddressInfo.value = false
  console.log(saved, 'saved')
  if (saved) {
    $toast('Added successfully', { type: 'success' })
  }
}

const handleAddCarts = () => {
  buriedPointUtil({ eventId: 'MPC202' })
  closeH5Sourcing()
  router.push('/carts')
}

const sourcingTipRef = ref(null)
const closeSourcingTip = () => {
  const el = sourcingTipRef.value
  el.style.height = 'auto'
  const h = el.offsetHeight
  el.style.height = `${h}px`
  el.style.opacity = 0
  el.offsetHeight
  el.style.height = 0
}

const isShowSourcingTip = (skuId) => {
  const visible = skuCartStatus.value.includes(String(skuId))

  if (visible) {
    const el = sourcingTipRef.value
    el.style.height = 'auto'
    const h = el.offsetHeight
    el.style.height = 0

    el.offsetHeight
    el.style.opacity = 1
    el.style.height = `${h}px`
  } else {
    closeSourcingTip()
  }
}

const contactUs = () => {
  showNewMessage()
}

const handleImagePreview = (index) => {
  showImagePreviewWithSimilar({
    images: images.value,
    startPosition: index,
    offerId: route.params.id
  })
}

/**
 * 待 firstrAttributes 初始化完成后，判断 query 是否存在 skuId，若存在则设置默认值
 */
watch(firstrAttributes, (list) => {
  const { skuId } = route.query
  if (list.length === 0 || skuId == null) return

  const selectedIndex = list.findIndex((v) => v.skuId === Number(skuId))
  if (selectedIndex === -1) return
  clickFirstAttributes(list[selectedIndex], selectedIndex)
})
</script>

<style lang="less">
@import "./index.less";
</style>
